export const REDUCER_NAME = "auth";

export const USER_SIGNED_UP = "Auth/USER_SIGNED_UP";
export const USER_LOGGED_IN = "Auth/USER_LOGGED_IN";
export const USER_LOGGING_IN = "Auth/USER_LOGGING_IN";
export const SOCKET_CONNECTED = "Auth/SOCKET_CONNECTED";
export const SOCKET_DISCONNECTED = "Auth/SOCKET_DISCONNECTED";
export const USER_LOGOUT = "Auth/USER_LOGOUT";
